import { render, staticRenderFns } from "./invoiceTemp_REBLS.vue?vue&type=template&id=25567e60&scoped=true&"
import script from "./invoiceTemp_REBLS.vue?vue&type=script&lang=js&"
export * from "./invoiceTemp_REBLS.vue?vue&type=script&lang=js&"
import style0 from "./invoiceTemp_REBLS.vue?vue&type=style&index=0&id=25567e60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25567e60",
  null
  
)

export default component.exports